import React, { useState } from 'react';

// components
import ModalForm from '../../../components/ModalForm/ModalForm';
import EmptyData from '../../../components/EmptyData/EmptyData';

// icons
import icon from '../../../brand/generated/buttonIcons/leadCreate.svg';

const formStyles = {
  dealInfo: { display: 'grid', gap: '20px', gridTemplateAreas: `'a a m m' 'b b b b' 'c c c c'` },
  autoForm: { display: 'grid', gap: '20px', gridTemplateColumns: `auto 44px` },
};

const dealInfo = [
  { type: 'input', value: '01.11.2022', label: 'ÐÐ°ÑÐ°', disabled: true },
  { type: 'input', label: 'ID', value: '35567809', disabled: true },
  { type: 'select', label: 'ÐÐ»Ð¸ÐµÐ½Ñ', placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°', style: { gridArea: 'm' } },
  { type: 'select', label: 'Ð¡ÑÐ°ÑÑÑ ÑÐ´ÐµÐ»ÐºÐ¸', placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°' },
  { type: 'select', label: 'Ð¤Ð¾ÑÐ¼Ð° Ð¾Ð¿Ð»Ð°ÑÑ', placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°' },
  { type: 'select', label: 'Ð¡ÑÐ°ÑÑÑ Ð¾Ð¿Ð»Ð°ÑÑ', placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°' },
  { type: 'input', label: 'Ð¡ÑÐ¼Ð¼Ð° ÑÐ´ÐµÐ»ÐºÐ¸, KZT', placeholder: 'ÐÐ²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¸Ð¹ ÑÐ°ÑÑÐµÑ', disabled: true },
  { type: 'input', label: 'ÐÐ°Ð¼ÐµÑÐºÐ¸/ÐºÐ¾Ð¼Ð¼ÐµÐ½ÑÐ°ÑÐ¸Ð¸ Ð¾ ÑÐ´ÐµÐ»ÐºÐµ', placeholder: 'ÐÐ°Ñ ÐºÐ¾Ð¼Ð¼ÐµÐ½ÑÐ°ÑÐ¸Ð¹', style: { gridArea: 'c' } },
];

const NewLeadClient = () => {
  const [showModal, setShowModal] = useState(false);

  const [autoForm, setAutoForm] = useState({
    title: 'ÐÐ²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ',
    style: formStyles.autoForm,
    action: 'ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ ÐµÑÐµ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ',
    form: [],
    add: [{ type: 'select', value: '', label: 'ÐÐ²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ', placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°' }, { type: 'delete' }],
  });

  const [equipmentForm, setEquipmentForm] = useState({
    title: 'ÐÐºÑÐµÑÑÑÐ°ÑÑ',
    style: formStyles.autoForm,
    action: 'ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ ÐµÑÐµ Ð¾Ð±Ð¾ÑÑÐ´Ð¾Ð²Ð°Ð½Ð¸Ðµ',
    form: [],
    add: [{ type: 'select', value: '', label: 'ÐÐ±Ð¾ÑÑÐ´Ð¾Ð²Ð°Ð½Ð¸Ðµ', placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°' }, { type: 'delete' }],
  });

  const [serviceForm, setServiceForm] = useState({
    title: 'ÐÐ¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÑÐ½ÑÐµ ÑÑÐ»ÑÐ³Ð¸',
    style: formStyles.autoForm,
    action: 'ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ ÐµÑÐµ Ð´Ð¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÑÐ½ÑÑ ÑÑÐ»ÑÐ³Ñ',
    form: [],
    add: [{ type: 'select', value: '', label: 'Ð£ÑÐ»ÑÐ³Ð°', placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°' }, { type: 'delete' }],
  });

  const [documentForm, setDocumentForm] = useState({
    title: 'ÐÐ¾ÐºÑÐ¼ÐµÐ½ÑÑ',
    style: formStyles.autoForm,
    action: 'ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ ÐµÑÐµ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ Ðº ÑÐ´ÐµÐ»ÐºÐµ',
    form: [],
    add: [{ type: 'select', value: 'Ð«Ð«Ð«Ð«', label: 'Ð£ÑÐ»ÑÐ³Ð°', placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°' }, { type: 'delete' }],
  });

  const [actions, setActions] = useState([
    { show: true, text: 'ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ' },
    { show: true, text: 'ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ Ð°ÐºÑÐµÑÑÑÐ°ÑÑ' },
    { show: true, text: 'ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ Ð´Ð¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÑÐ½ÑÑ ÑÑÐ»ÑÐ³Ñ' },
    { show: true, text: 'ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ Ðº ÑÐ´ÐµÐ»ÐºÐµ' },
  ]);

  return (
    <>
      <EmptyData
        title={'ÐÐ»Ð¸ÐµÐ½Ñ'}
        subtitle={'Ð­ÑÐ¾ Ð»Ð¸Ð´ ÐµÑÐµ Ð½Ðµ ÐºÐ¾Ð½Ð²ÐµÑÑÐ¸ÑÐ¾Ð²Ð°Ð½ Ð² ÐºÐ»Ð¸ÐµÐ½ÑÐ°...'}
        action="Ð¡Ð¾Ð·Ð´Ð°ÑÑ ÐºÐ»Ð¸ÐµÐ½ÑÐ° Ð¸Ð· Ð»Ð¸Ð´Ð°"
        icon={icon}
        func={() => setShowModal(true)}
      />
      {showModal && (
        <div
          style={{
            width: '100%',
            height: '100%',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: 'rgba(0, 0, 0, 0.3)',
            display: 'flex',
          }}
        >
          <div style={{ width: '316px' }} />
          <ModalForm
            title={'ÐÐ¾Ð²Ð°Ñ ÑÐ´ÐµÐ»ÐºÐ° Ñ ÐºÐ»Ð¸ÐµÐ½ÑÐ¾Ð¼'}
            closeModal={() => setShowModal(false)}
            mainForm={dealInfo}
            formTitle={'ÐÐ½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ Ð¾ ÑÐ´ÐµÐ»ÐºÐµ'}
            grid={formStyles.dealInfo}
            forms={[autoForm, equipmentForm, serviceForm, documentForm]}
            actions={actions}
            setActions={setActions}
            setForm={[setAutoForm, setEquipmentForm, setServiceForm, setDocumentForm]}
            button={'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ ÑÐ´ÐµÐ»ÐºÑ'}
          />
        </div>
      )}
    </>
  );
};

export default NewLeadClient;
